import { memo } from 'react';

import { type StripePaymentProviderProps } from '../../types';

export const StripePaymentProvider = memo(
  (props: StripePaymentProviderProps) => {
    const { children } = props;

    return children;
  },
);
